import redirect from '../redirect';

export const back = () => {
  if (window.history.state) {
    window.history.back();
  } else {
    redirect('/notebook');
  }
};
